import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const YandexMetrica = () => {
  const location = useLocation();

  useEffect(() => {
    if (window.ym) {
      window.ym(12345678, 'hit', location.pathname + location.search);
    }
  }, [location]);

  return null;
};

export default YandexMetrica;